export default __webpack_public_path__ + "static/media/clock-icon.efc6bc4e.svg";